import { cn } from "@/lib/tailwind";
import React, { ElementRef, forwardRef } from "react";
import { ITriggerProps } from "./types";

export interface ISelectTriggerProps extends ITriggerProps {
  onToggle: () => void;
  label: React.ReactNode;
  endAction?: React.ReactNode;
}

export const Trigger = forwardRef<ElementRef<"button">, ISelectTriggerProps>(
  ({ label, endIcon, disabled, error, onToggle, className, endAction, ...restProps }, ref) => (
    <button
      type="button"
      ref={ref}
      onClick={onToggle}
      disabled={disabled}
      aria-invalid={Boolean(error?.error)}
      className={cn(
        "flex h-10 w-[10rem] items-center justify-between gap-4 overflow-hidden px-3 py-2 text-[0.813rem] font-normal",
        "border-2 border-black bg-white text-black hover:bg-gray-50 hover:text-gray-700 focus:outline-none",
        error?.error && "border border-secondary-1",
        disabled && "cursor-not-allowed opacity-50",
        className,
      )}
      {...restProps}
    >
      <span className="sr-only">Select option</span>
      {typeof label === "string" ? <span>{label}</span> : label}
      <div className="flex items-center gap-2">
        {endAction}
        {endIcon || (
          <svg
            className="size-4"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clipRule="evenodd"
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            />
          </svg>
        )}
      </div>
    </button>
  ),
);
